import zipObject from 'lodash/zipObject';

export default function keyMirror(...names) {
  return zipObject(names, names);
}
